import type { RootState } from "types";

export const getIsPresentationDownloading = (state: RootState) => state.domains.topic.isPresentationDownloading;
